import React, { useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import axios from "axios";

const AUTH_API = (process.env.REACT_APP_API_URL || "") + "/api/auth";

export default function ResetPasswordPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get("token") || "";

  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);

  if (!token) {
    return (
      <div className="container">
        <div className="form">
          <h2>Invalid Link</h2>
          <p style={{ color: "#666" }}>This password reset link is missing or malformed.</p>
          <button onClick={() => navigate("/login")}>Back to Login</button>
        </div>
      </div>
    );
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    if (password !== confirm) {
      setError("Passwords do not match.");
      return;
    }
    if (password.length < 8) {
      setError("Password must be at least 8 characters.");
      return;
    }
    setLoading(true);
    try {
      await axios.post(`${AUTH_API}/password-reset/confirm/`, { token, password });
      setSuccess(true);
    } catch (err) {
      setError(err.response?.data?.error || "Something went wrong. Please try again.");
    }
    setLoading(false);
  };

  if (success) {
    return (
      <div className="container">
        <div className="form">
          <h2>Password Updated</h2>
          <p style={{ color: "green", textAlign: "center" }}>
            Your password has been reset. You can now log in.
          </p>
          <button onClick={() => navigate("/login")}>Go to Login</button>
        </div>
      </div>
    );
  }

  return (
    <div className="container">
      <form className="form" onSubmit={handleSubmit}>
        <h2 style={{ marginBottom: "0.5rem" }}>Set New Password</h2>
        <label>
          New Password:{" "}
          <input
            type="password"
            required
            value={password}
            onChange={e => setPassword(e.target.value)}
            autoFocus
            minLength={8}
          />
        </label>
        <label>
          Confirm Password:{" "}
          <input
            type="password"
            required
            value={confirm}
            onChange={e => setConfirm(e.target.value)}
          />
        </label>
        {error && <p className="error">{error}</p>}
        <button type="submit" disabled={loading}>
          {loading ? "Saving..." : "Set Password"}
        </button>
      </form>
    </div>
  );
}
